
<!--  https://www.tiny.cloud/docs/integrations/vue/ -->
<Editor
  ref="ref_tiny"
  v-bind="$attrs"
  v-on="$listeners"
  api-key="fe0y901m81ya8heur0k7zkcsvv7pwdus8hnji8b7604xshfv"
  :init="myInit"
/>
